import BASE_API from '@/api/dataBase';
export const tableColumns = (ctx) => {
  return [
    {
      name: '业务类别',
      prop: 'settlementBusinessType',
      type: 'select',
      disabled: true,
      options: [
        { value: '01', label: '贸易' },
        { value: '02', label: '多式联运' },
        { value: '03', label: '园区仓储' },
        { value: '04', label: '园区物业' },
        { value: '05', label: '监管单' },
      ],
    },
    {
      prop: 'settlementCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'settlementDepartmentNo',
      name: '部门',
      type: 'select',
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: 'changeMethod',
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'superviseContract',
      extraData: {
        // contractStatus: 'ZT03',
        // contractType: '0',
        // isCS: 'S',
        // createDepartmentNo: ctx.baseFormData.settlementDepartmentNo,
        // // createDepartmentNo: 'OAD2',
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
      currentValue: ctx.baseFormData?.contractNo,
      disabled: !ctx.isCreate,
    },
    {
      name: '客户名称',
      prop: 'customerName',
      type: 'input',
      disabled: true,
    },

    {
      name: '项目编号',
      prop: 'projectInitiationNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '结算单编号',
      prop: 'settlementNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '结算类型',
      prop: 'settlementType',
      type: 'select',
      options: ctx.dictListMap?.settlementType || [],
      disabled: !ctx.isCreate,
    },
    {
      name: '结算日期',
      prop: 'settlementDate',
      type: 'date',
    },
    {
      name: '原币结算总金额（含税）',
      prop: 'originalTotalAmount',
      type: 'inputNumber',
      disabled: true,
    },
    {
      name: '本币结算总金额（含税）',
      prop: 'domesticTotalAmount',
      type: 'inputNumber',
      disabled: true,
    },
    {
      name: '币种',
      prop: 'currencyCode',
      type: 'ajaxSelect',
      apiUrl: BASE_API.LIST_CURRENCY,
      clearable: true,
      filterable: true,
      valueKey: 'currencyCode',
      labelKey: 'currencyName',
      changeMethod: 'changeMethod',
      method: 'get',
      valueType: 'object',
      disabled: true,
    },
    {
      name: '汇率值',
      prop: 'exchangeRate',
      type: 'inputNumber',
      disabled: true,
    },
    {
      name: '汇率日期',
      prop: 'exchangeDate',
      type: 'date',
    },
    {
      name: '应收账期',
      prop: 'receivableAccountPeriod',
      type: 'date',
      format: 'yyyy-MM',
      disabled: !ctx.isCreate,
    },
    {
      name: '结算单状态',
      prop: 'settlementStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementStatus || [],
      disabled: true,
    },
    {
      name: '开票状态',
      prop: 'settlementIssueStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementIssueStatus || [],
      disabled: true,
    },
    {
      name: '开票金额',
      prop: 'applyInvoiceAmount',
      type: 'inputNumber',
      precision: 2,
      disabled: true,
    },
    {
      name: '收款状态',
      prop: 'receiveStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementReceiveStatus || [],
      disabled: true,
    },
    {
      name: '已收款金额',
      prop: 'collectedAmount',
      type: 'inputNumber',
      precision: 2,
      disabled: true,
    },
    {
      name: '已打印',
      prop: 'printFlag',
      type: 'checkbox',
      labelPosition: 'right',
      disabled: true,
    },
    {
      name: '创建日期',
      prop: 'settlementCreateDate',
      type: 'date',
      disabled: true,
    },
    {
      name: '业务人员',
      prop: 'salesmanName',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      currentValue: ctx.baseFormData?.salesmanName,
      disabled: true,
    },
    // {
    //   name: '业务人员',
    //   prop: 'salesmanNo',
    //   type: 'searchTableSpec',
    //   searchType: 'personnel',
    //   isMultiple: true,
    //   changeMethod: 'changeMethod',
    //   currentValue: ctx.baseFormData?.salesmanName,
    // },
    {
      name: '备注',
      prop: 'remark',
      type: 'textarea',
      span: 24,
    },
  ];
};
import { formatDate } from '@/utils/date';
export default {
  name: 'SuperviseContractForm',
  data() {
    return {
      baseFormData: {
        settlementBusinessType: '05',
        settlementCompanyNo: '',
        settlementCompanyName: '',
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        customerNo: '',
        customerName: '',
        settlementNo: '',
        settlementType: '',
        settlementDate: undefined,
        contractNo: '',
        originalTotalAmount: '',
        domesticTotalAmount: '',
        currencyCode: '',
        currencyName: '',
        exchangeRate: '',
        exchangeDate: '',
        receivableAccountPeriod: '',
        settlementStatus: '',
        settlementIssueStatus: '02',
        collectedAmount: '0',
        applyInvoiceAmount: '0',
        printFlag: false,
        settlementCreateDate: '',
        salesmanName: '',
        salesmanNo: '',
        remark: '',
      },
      companyList: [],
      departmentList: [],
    };
  },
  computed: {
    baseColumns() {
      return tableColumns(this);
    },
    baseRules() {
      return {
        settlementCompanyNo: [{ required: true, message: '请选择公司名称', trigger: 'change' }],
        settlementDepartmentNo: [{ required: true, message: '请选择部门', trigger: 'change' }],
        customerNo: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
        settlementDate: [{ required: true, message: '请选择结算日期', trigger: 'change' }],
        contractNo: [{ required: true, message: '请选择合同编号', trigger: 'change' }],
        customerName: [{ required: true, message: '请选择客户名称', trigger: 'change' }],
        settlementType: [{ required: true, message: '请选择结算类型', trigger: 'change' }],
        originalTotalAmount: [
          { required: true, message: '请输入原币总金额含税', trigger: 'change' },
        ],
        domesticTotalAmount: [
          { required: true, message: '请输入本币总金额含税', trigger: 'change' },
        ],
        currencyCode: [{ required: true, message: '请选择币种', trigger: 'change' }],
        exchangeDate: [{ required: true, message: '请选择汇率日期', trigger: 'blur' }],
        exchangeRate: [{ required: true, message: '请输入汇率值', trigger: 'change' }],
        receivableAccountPeriod: [{ required: true, message: '请选择应收账期', trigger: 'blur' }],
        settlementBusinessType: [{ required: true, message: '请选择业务类别', trigger: 'change' }],
        salesmanName: [{ required: true, message: '请选择业务员', trigger: 'change' }],
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this._getCompanyApi();
    });
    this.initFormData();
    console.log('this.userInfo', this.userInfo);
  },
  methods: {
    // 初始化表单数据
    initFormData() {
      if (['create'].includes(this.$route.query?.status)) {
        console.log('初始化===');
        this.baseFormData = {
          ...this.baseFormData,
          settlementBusinessType: '05',
          settlementCompanyNo: this.userInfo.companyCode,
          settlementCompanyName: this.userInfo.companyName,
          settlementDepartmentNo: this.userInfo.departmentCode,
          settlementDepartmentName: this.userInfo.departmentName,
          salesmanNo: this.userInfo.userCode,
          salesmanName: this.userInfo.userName,
          originalTotalAmount: '0',
          domesticTotalAmount: '0',
          settlementType: '2',
          settlementCreateDate: formatDate(new Date()),
          // settlementIssueStatus: '01',
        };
      }
    },
    async changeMethod({ val, prop }) {
      console.log(val, prop, '点击切换');
      const rowData = val && Array.isArray(val) ? val[0] : val;
      if (prop == 'settlementCompanyNo') {
        if (val) {
          await this._getDepartmentByCompanyCodeApi(val);
        }
        // 选择公司
        const currentItem = this.companyList.find((item) => item.value == val);
        this.baseFormData = Object.assign(this.baseFormData, {
          settlementDepartmentNo: '',
          settlementDepartmentName: '',
          settlementCompanyNo: val,
          settlementCompanyName: currentItem?.label,
        });
      } else if (prop == 'salesmanName') {
        this.baseFormData = {
          ...this.baseFormData,
          salesmanName: rowData.personName,
          salesmanNo: rowData.personNo,
        };
      } else if (prop == 'settlementDepartmentNo') {
        const currentItem = this.departmentList.find((item) => item.value == val);
        this.baseFormData = Object.assign(this.baseFormData, {
          settlementDepartmentNo: val,
          settlementDepartmentName: currentItem?.label,
        });
      } else if (prop == 'contractNo') {
        console.log('jiesuanzhuti', rowData.settlementEntityName, rowData.settlementEntityNo);
        this.baseFormData = {
          ...this.baseFormData,
          projectInitiationNo: rowData?.projectNo,
          projectName: rowData?.projectName,
          contractNo: rowData?.contractNo,
          supplierNo: rowData?.supplierCode,
          supplierName: rowData?.supplierName,
          companyCode: rowData?.companyCode,
          departmentCode: rowData?.departmentCode,
          companyName: rowData?.companyName,
          departmentName: rowData?.departmentName,
          // settlementStatus: rowData?.contractStatus,
          originalTotalAmount: '0',
          domesticTotalAmount: '0',
          currencyCode: rowData?.currencyCode || 'CNY',
          currencyName: rowData?.currencyName || '中国人民币（国际）',
          exchangeRate: rowData?.exchangeRate || '1',
          customerNo: rowData?.settlementEntityNo,
          customerName: rowData?.settlementEntityName,
        };
        // 切换合同的时候清空数据
        this.clearAccountTableData();
      } else if (prop == 'customerNo') {
        this.baseFormData = {
          ...this.baseFormData,
          customerNo: rowData.customerNo,
        };
      } else if (prop === 'currencyCode') {
        this.baseFormData = {
          ...this.baseFormData,
          currencyCode: val?.currencyCode,
          currencyName: val?.currencyName,
        };
      }
    },

    // 获取公司
    async _getCompanyApi() {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        this.companyList = data.data?.personCompanyInfo;
        // console.log("this.com",this.companyList)
        this._getDepartmentByCompanyCodeApi(this.baseFormData.settlementCompanyNo);
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode) {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        this.departmentList = data.data?.personDepartmentInfo;
      } else {
        console.error('获取部门失败');
      }
    },
    // 切换公司
    changeCompanyHandler(val) {
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        settlementCompanyNo: val,
        settlementCompanyName: item.personCompanyName,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: val,
        settlementDepartmentName: item.personDepartmentName,
      };
    },
  },
};
